import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LandingConversion } from '../model/landing-conversion/landing-conversion.model';
@Injectable({
  providedIn: 'root',
})
export class LandingConversionsService {
  private landingConversionContextSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private selectedConversionSubject: BehaviorSubject<LandingConversion> = new BehaviorSubject<LandingConversion>(null);
  constructor(private httpClient: HttpClient) {}

  setLandingConversionContext$(isLandingConversion: boolean): void {
    this.landingConversionContextSubject.next(isLandingConversion);
  }
  setSelectedConversion$(conversion: LandingConversion): void {
    this.selectedConversionSubject.next(conversion);
  }
  get selectedConversion$(): Observable<LandingConversion> {
    return this.selectedConversionSubject.asObservable();
  }

  get isLandingConversionContext$(): boolean {
    return this.landingConversionContextSubject.getValue();
  }

  getLandingConversions(): Observable<LandingConversion[]> {
    const url = `${environment.newApiBaseUrl}/classification-history/pending-landing-conversions`;

    return this.httpClient.get<LandingConversion[]>(url);
  }
}
